import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";
import { trackEvents } from "./amplitude/amplitude";

export const reportWebVitals = () => {
  const metrics = {};
  const expectedMetrics = ["LCP", "CLS", "INP", "TTFB", "FCP"];

  const collectMetric = (metric) => {
    metrics[metric.name] = {
      value: metric.value,
      rating: metric.rating,
      delta: metric.delta,
      id: metric.id,
      navigationType: metric.navigationType,
    };

    // Send combined event once all metrics are collected
    if (Object.keys(metrics).length === expectedMetrics.length) {
      trackEvents("page_performance", {
        // LCP
        lcp_value: metrics.LCP?.value,
        lcp_rating: metrics.LCP?.rating,
        lcp_delta: metrics.LCP?.delta,
        lcp_id: metrics.LCP?.id,
        lcp_navigation_type: metrics.LCP?.navigationType,
        // CLS
        cls_value: metrics.CLS?.value,
        cls_rating: metrics.CLS?.rating,
        cls_delta: metrics.CLS?.delta,
        cls_id: metrics.CLS?.id,
        cls_navigation_type: metrics.CLS?.navigationType,
        // INP
        inp_value: metrics.INP?.value,
        inp_rating: metrics.INP?.rating,
        inp_delta: metrics.INP?.delta,
        inp_id: metrics.INP?.id,
        inp_navigation_type: metrics.INP?.navigationType,
        // TTFB
        ttfb_value: metrics.TTFB?.value,
        ttfb_rating: metrics.TTFB?.rating,
        ttfb_delta: metrics.TTFB?.delta,
        ttfb_id: metrics.TTFB?.id,
        ttfb_navigation_type: metrics.TTFB?.navigationType,
        // FCP
        fcp_value: metrics.FCP?.value,
        fcp_rating: metrics.FCP?.rating,
        fcp_delta: metrics.FCP?.delta,
        fcp_id: metrics.FCP?.id,
        fcp_navigation_type: metrics.FCP?.navigationType,
        // Page info
        page_url: window.location.pathname,
      });
    }
  };

  onLCP(collectMetric);
  onCLS(collectMetric);
  onINP(collectMetric);
  onTTFB(collectMetric);
  onFCP(collectMetric);
};
